export default __webpack_public_path__ + "static/media/SvenBeckertOld.375ccb94.png";